'use client'

import { useTheme } from 'next-themes'

import DarkMode from '../../icons/DarkMode'
import LightMode from '../../icons/LightMode'
import Settings from '../../icons/Settings'
import { cn } from '../../utils/cn'
import { SegmentedControlItem, SegmentedControlList } from '../_base/SegmentedControl'
import { Tabs } from '../_base/Tabs'

interface ThemeSegmentedControlProps {
  className?: string
}

export function ThemeSegmentedControl({ className }: ThemeSegmentedControlProps) {
  const { theme, setTheme } = useTheme()

  return (
    <Tabs
      value={theme ?? ''}
      onValueChange={value => {
        if (value) setTheme(value)
      }}
      className={cn('gap-0', className)}
    >
      <SegmentedControlList className="w-full">
        <SegmentedControlItem value="system" aria-label="Auto mode" className="flex-1">
          <Settings className="size-5" />
        </SegmentedControlItem>
        <SegmentedControlItem value="dark" aria-label="Dark mode" className="flex-1">
          <DarkMode className="size-5" />
        </SegmentedControlItem>
        <SegmentedControlItem value="light" aria-label="Light mode" className="flex-1">
          <LightMode className="size-5" />
        </SegmentedControlItem>
      </SegmentedControlList>
    </Tabs>
  )
}
